module.exports = __webpack_public_path__ + "img/PáginaLarchitteto.a56e422f.jpg";